<template>
  <v-container fluid>
    <v-card :loading="loading" class="mt-0 pt-0">
      <v-toolbar
        dark
        color="green"
        class="mt-0"
        dense
      >
        <v-toolbar-title>Statystyki: {{ FACILITY.name }}</v-toolbar-title>

      </v-toolbar>
      <StatsDashboard
        v-if="FACILITY.id"
        :facility="FACILITY"
      />
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import StatsDashboard from "./../../FacilityEdit/Stats/StatsDashboard";

export default {
  name: "WindowStats",
  components: {
    StatsDashboard,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters(["FACILITY"]),
  },
  methods: {
    successMessage(message) {
      this.$refs.snackbar.success(message);
    },
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("GET_FACILITY_BY_ID", { id: this.$route.params.id })
      .then(() => {
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        console.log(error);
      });
  },
};
</script>


<style>
</style>